import { Navigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useGetUserQuery } from "../../query/usersQuery";
import { UserRole } from "@KassaroAB/shared/types/enums/UserRole";
import { LoadingContainer } from "../../components/LoadingContainer";

interface ResellerGuardProps {
  children: React.ReactNode;
}

export const ResellerGuard = ({ children }: ResellerGuardProps) => {
  const { t } = useTranslation();
  const { resellerId } = useParams<{ resellerId: string }>();
  const { data: user, isLoading } = useGetUserQuery();

  if (isLoading || !user) {
    return <LoadingContainer message={t("common.loading")} />;
  }

  if (user.role === UserRole.ADMIN) {
    return <>{children}</>;
  }

  if (user.role === UserRole.RESELLER_ADMIN && user.resellerId === resellerId) {
    return <>{children}</>;
  }

  if (user.role === UserRole.RESELLER_ADMIN && user.resellerId) {
    return <Navigate to={`/resellers/${user.resellerId}`} replace />;
  }

  return <Navigate to="/" replace />;
};
